import BreadCrumb from 'components/ui/breadcrumb'
import styles from './index.module.scss'

const SeoPageTemplate = (props) => {
  const { children } = props
  return (
    <>
      <div className={styles['page-seo']}>
        <BreadCrumb
          breadcrumb={props.breadcrumb}
          breadcrumbHead={props.breadcrumbHead}
          className="v3"
          addHead
        />
        {children}
      </div>
    </>
  )
}
export default SeoPageTemplate
